import CompTableListing from './custom/TableListing.vue';
export const TableListing = CompTableListing;
export default CompTableListing;
